/*eslint-disable*/
import React, { useEffect, useState } from "react";
import {
	Card,
	CardBody,
	Label,
	FormGroup,
	Row,
	Input,
	CardHeader,
	Col,
	Button,
	Table,
    CardImg,
    CardFooter,
    CardGroup,
	Container,
	Form,
} from "reactstrap";
import { Link, useHistory } from "react-router-dom";
import axios from "axios";
import SimpleHeader from "components/Headers/SimpleHeader.js";

export default function Userss() {
	const token = localStorage.token;
	const warehouseId = localStorage.warehouse;
	const username = localStorage.username;

	let history = useHistory();
    const [warehouse,setWarehouse] = useState("");
    const [warehouses,setWarehouses] = useState([]);
    const [isLoading,setLoading] = useState(false);
    const [posisi,setPosisi] = useState("");
    const [departement,setDepartement] = useState("");
    const [awal,setAwal] = useState("");
    // const [resign,setResign] = useState("");
    const [gender,setGender] = useState([]);
    const [nik,setNik] = useState("");
    const [ktp,setKtp] = useState("");
    const [image,setImage] = useState("");
    const [name,setName] = useState("");
    const [divisi,setDivisi] = useState("");
    const [jabatan,setJabatan] = useState("");
    const [kelahiran,setKelahiran] = useState("");
    const [sim,setSim] = useState("");
    const [nosim,setNoSim] = useState("");
    const [statuskk,setStatusKK] = useState("");
    const [namakk,setNamaKK] = useState("");
    const [genderkk,setGenderKK] = useState("");
    const [alamatkk,setAlamatKK] = useState("");
    const [teleponkk,setTeleponKK] = useState("");
    const [hubungankk,setHubunganKK] = useState("");
    const [masasim,setMasaSim] = useState("");
    const [provinces, setProvinces] = useState([]);
    const [province, setProvince] = useState([]);
    const [citys, setCitys] = useState([]);
    const [city,setCity] = useState([]);
    const [alamat, setAlamat] = useState("");
    const [unit, setUnit] = useState("");
    const [units, setUnits] = useState([])
    const [group, setGroup] = useState("")
    const [groups, setGroups] = useState([])

    useEffect(() => {
      getWarehouse();
      getGroup();
      getUnit();
      getProvinsi();
      getKota();
    }, []);

        const getWarehouse = () => {
            const headers = {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            };
        axios
            .get(
            `${process.env.REACT_APP_API_BASE_URL}/warehouse/list/all`,
            { headers }
            )
            .then((data) => {
            setWarehouses(data.data.response);
            })
            .catch(function (error) {
            console.log(error);
            });
        };

        const getGroup = () => {
            const headers = {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            };
        axios
            .get(
            `${process.env.REACT_APP_API_BASE_URL}/group/list`,
            { headers }
            )
            .then((data) => {
            setGroups(data.data.response);
            })
            .catch(function (error) {
            console.log(error);
            });
        };

        const getUnit = () => {
            const headers = {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            };
        axios
            .get(
            `${process.env.REACT_APP_API_BASE_URL}/unit/list`,
            { headers }
            )
            .then((data) => {
            setUnits(data.data.response);
            })
            .catch(function (error) {
            console.log(error);
            });
        };
    
      const getProvinsi = () => {
        const headers = {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`
          }
        axios.get(`${process.env.REACT_APP_API_BASE_URL}/province/list`, { headers
        })
        .then(data => {
          setProvinces(data.data.response_data);
        })
          .catch(function (error) {
            console.log(error)
          })
      }
    
      const getKota = (id) => {
        const headers = {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`
          }
        axios.get(`${process.env.REACT_APP_API_BASE_URL}/city?province_id=${id}`, { headers
        })
        .then(data => {
          setCitys(data.data.response_data);
        })
          .catch(function (error) {
            console.log(error)
          })
      }

    function CreateData() {
      setLoading(true);
      const headers = {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${token}`,
      };
      const myjson = JSON.stringify({
        warehouse_id: parseInt(warehouseId),
        nik: nik,
        ktp: ktp,
        name:name,
        gender: parseInt(gender),
        kelahiran: kelahiran,
        address: alamat, 
        province:parseInt(province),
        city: parseInt(city),
        sim: sim,
        nomor_sim:parseInt(nosim),
        masa_sim: masasim,
        status_kk:statuskk,
        nama_kk:namakk,
        gender_kk:parseInt(genderkk),
        alamat_kk:alamatkk,
        telepon_kk:teleponkk,
        hubungan_kk:hubungankk,
        recruit:awal,
        active_flag:1,
        group_id : parseInt(group),
        unit_id : parseInt(unit)
      });
      let data = new FormData();
      data.append("body",myjson)
      data.append("profile",image)
      axios.post(`${process.env.REACT_APP_API_BASE_URL}/karyawan/save`, data, {
        headers
      })
        .then(function (response) {
          history.push("/admin/karyawan");
        })
        .then(json => {
          setLoading(false);
        })
        .catch(function (error) {
          console.log(error)
        })
    }


	return (
		<>
			<div>
				<SimpleHeader name="Daftar Karyawan" parentName="Master" />
				<Container className="mt--6" fluid>
					<Row>
						<div className="col">
                            <Card className="bg-secondary shadow">
                                <CardHeader className="bg-white border-0">
                                    <h3>Daftar Karyawan</h3>
                                </CardHeader>
                                <Row md="12">
                                    <Col md="6">
                                        <CardBody>
                                            <FormGroup row>
                                            <Label for="exampleEmail" sm={4}>
                                                Cabang
                                            </Label>
                                            <Col sm={7}>
                                                <Input
                                                autoComplete="off"
                                                className="form-control-alternative"
                                                name="person"
                                                type="select"
                                                value={warehouse}
                                                onChange={(e) => {
                                                    setWarehouse(e.target.value);
                                                }}
                                                >
                                                <option value=''>Pilih Cabang</option>
                                                {warehouses.map((warehouse2, key) => {
                                                    return (
                                                        <option key={key} value={warehouse2.id}>
                                                        {warehouse2.name}
                                                        </option>
                                                    );
                                                    })}
                                                </Input>
                                            </Col>
                                            </FormGroup>
                                            <FormGroup row>
                                                <Label for="exampleEmail" sm={4}>
                                                    NIP
                                                </Label>
                                                <Col sm={7}>
                                                    <Input
                                                    autoComplete="off"
                                                        className="form-control-alternative"
                                                        type="text"
                                                       
                                                        placeholder="Masukan Nomor Induk Pegawai"
                                                        value={nik}
                                                        onChange={(e) => {
                                                            setNik(e.target.value);
                                                        }}
                                                    />
                                                </Col>
                                            </FormGroup>
                                            <FormGroup row>
                                                <Label for="exampleEmail" sm={4}>
                                                    KTP
                                                </Label>
                                                <Col sm={7}>
                                                    <Input
                                                    autoComplete="off"
                                                        className="form-control-alternative"
                                                        type="text"
                                                       
                                                        placeholder="Masukan KTP"
                                                        value={ktp}
                                                        onChange={(e) => {
                                                            setKtp(e.target.value);
                                                        }}
                                                    />
                                                </Col>
                                            </FormGroup>
                                            <FormGroup row>
                                                <Label for="exampleEmail" sm={4}>
                                                    Nama
                                                </Label>
                                                <Col sm={7}>
                                                    <Input
                                                    autoComplete="off"
                                                        className="form-control-alternative"
                                                        type="text"
                                                        name="barcode"
                                                        placeholder="Masukan Nama"
                                                        value={name}
                                                        onChange={(e) => {
                                                            setName(e.target.value);
                                                        }}
                                                    />
                                                </Col>
                                            </FormGroup>
                                            <FormGroup row>
                                                <Label for="exampleEmail" sm={4}>
                                                    Kelahiran
                                                </Label>
                                                <Col sm={7}>
                                                    <Input
                                                    autoComplete="off"
                                                        className="form-control-alternative"
                                                        type="date"
                                                       
                                                        placeholder="Masukan Kelahiran"
                                                        value={kelahiran}
                                                        onChange={(e) => {
                                                            setKelahiran(e.target.value);
                                                        }}
                                                    />
                                                </Col>
                                            </FormGroup>
                                            <FormGroup row>
                                                <Label
                                                    for="exampleEmail"
                                                    sm={4}
                                                >
                                                    Provinsi
                                                    
                                                </Label>
                                                <Col sm={7}>
                                                    <Input
                                                    autoComplete="off"
                                                        className="form-control-alternative"
                                                        type="select"
                                                        value={province}
                                                        onChange={(e) => {
                                                        setProvince(e.target.value);
                                                        getKota(e.target.value);
                                                        }}
                                                    >
                                                        <option>Pilih Provinsi</option>
                                                        {
                                                        provinces.map((a, key) => {
                                                            return <option key={key} value={a.id}>{a.name}</option>
                                                        })
                                                        }
                                                    </Input>
                                                </Col>
                                            </FormGroup>
                                            <FormGroup row>
                                                <Label
                                                    for="exampleEmail"
                                                    sm={4}
                                                >
                                                    Kota
                                                </Label>
                                                <Col sm={7}>
                                                    <Input
                                                    autoComplete="off"
                                                        className="form-control-alternative"
                                                        name="function"
                                                        type="select"
                                                        value={city}
                                                        onChange={(e) => {
                                                        setCity(e.target.value);
                                                        }}
                                                    >
                                                        <option>Pilih Kota</option>
                                                        {
                                                        citys.map((b, key) => {
                                                            return <option key={key} value={b.id}>{b.name}</option>
                                                        })
                                                        }
                                                    </Input>
                                                </Col>
                                            </FormGroup>
                                            <FormGroup row>
                                                <Label
                                                    for="exampleEmail"
                                                    sm={4}
                                                >
                                                    Alamat
                                                </Label>
                                                <Col sm={7}>
                                                    <Input
                                                    autoComplete="off"
                                                        className="form-control-alternative"
                                                        placeholder="Masukan Alamat"
                                                        Rows="5"
                                                        type="textarea"
                                                        value={alamat}
                                                        onChange={(e) => {
                                                        setAlamat(e.target.value);
                                                        }}
                                                    />
                                                </Col>
                                            </FormGroup>
                                            <FormGroup row>
                                                <Label
                                                for="exampleEmail"
                                                sm={4}
                                                >
                                                Jenis Kelamin
                                                </Label>
                                                <Col sm={7}>
                                                    <div style={{ display: "flex" }}>
                                                        <div className="custom-control custom-radio mb-4">
                                                            <Input
                                                            autoComplete="off"
                                                            className="custom-control-input"
                                                            id="customRadio10"
                                                            name="custom-radio-4"
                                                            type="radio"
                                                            value={1}
                                                            checked={gender === 1}
                                                            onChange={() => setGender(1)}
                                                            />
                                                            <Label
                                                            className="custom-control-label"
                                                            htmlFor="customRadio10"
                                                            >
                                                            Laki-Laki
                                                            </Label>
                                                        </div>
                                                        <div
                                                            className="custom-control custom-radio mb-4"
                                                            style={{ marginLeft: "20px" }}
                                                        >
                                                            <Input
                                                            autoComplete="off"
                                                            className="custom-control-input"
                                                            id="customRadio11"
                                                            name="custom-radio-4"
                                                            type="radio"
                                                            value={2}
                                                            checked={gender === 2}
                                                            onChange={() => setGender(2)}
                                                            />
                                                            <Label
                                                            className="custom-control-label"
                                                            htmlFor="customRadio11"
                                                            >
                                                            Perempuan
                                                            </Label>
                                                        </div>
                                                    </div>
                                                </Col>
                                            </FormGroup>
                                        </CardBody>
                                    </Col>
                                    <Col md="6">
                                        <CardBody>
                                            <FormGroup row>
                                                <Label for="exampleEmail" sm={4}>
                                                    Jabatan
                                                </Label>
                                                <Col sm={7}>
                                                    <Input
                                                    autoComplete="off"
                                                    className="form-control-alternative"
                                                    name="person"
                                                    type="select"
                                                    value={group}
                                                    onChange={(e) => {
                                                        setGroup(e.target.value);
                                                    }}
                                                    >
                                                    <option value=''>Pilih Jabatan</option>
                                                    {groups.map((warehouse2, key) => {
                                                        return (
                                                            <option key={key} value={warehouse2.id}>
                                                            {warehouse2.name}
                                                            </option>
                                                        );
                                                        })}
                                                    </Input>
                                                </Col>
                                            </FormGroup>
                                            <FormGroup row>
                                                <Label for="exampleEmail" sm={4}>
                                                    Unit
                                                </Label>
                                                <Col sm={7}>
                                                    <Input
                                                    autoComplete="off"
                                                    className="form-control-alternative"
                                                    name="person"
                                                    type="select"
                                                    value={unit}
                                                    onChange={(e) => {
                                                        setUnit(e.target.value);
                                                    }}
                                                    >
                                                    <option value=''>Pilih Unit</option>
                                                    {units.map((warehouse2, key) => {
                                                        return (
                                                            <option key={key} value={warehouse2.id}>
                                                            {warehouse2.name}
                                                            </option>
                                                        );
                                                        })}
                                                    </Input>
                                                </Col>
                                            </FormGroup>
                                            <FormGroup row>
                                                <Label for="exampleEmail" sm={4}>
                                                    SIM
                                                </Label>
                                                <Col sm={7}>
                                                    <Input
                                                    autoComplete="off"
                                                        className="form-control-alternative"
                                                        type="select"
                                                       
                                                        placeholder="Masukan SIM"
                                                        value={sim}
                                                        onChange={(e) => {
                                                            setSim(e.target.value);
                                                        }} >
                                                        <option value="" disabled selected hidden>Pilih SIM</option>
                                                        <option value="A">A</option>
                                                        <option value="BUmum">B Umum</option>
                                                        <option value="B1">B1</option>
                                                        <option value="B2">B2</option>
                                                        <option value="C">C</option>
                                                        <option value="D">D</option>
                                                    </Input>
                                                </Col>
                                            </FormGroup>
                                            <FormGroup row>
                                                <Label for="exampleEmail" sm={4}>
                                                    No SIM
                                                </Label>
                                                <Col sm={7}>
                                                    <Input
                                                    autoComplete="off"
                                                        className="form-control-alternative"
                                                        type="text"
                                                       
                                                        placeholder="Masukan No SIM"
                                                        value={nosim}
                                                        onChange={(e) => {
                                                            setNoSim(e.target.value);
                                                        }}
                                                    />
                                                </Col>
                                            </FormGroup>
                                            <FormGroup row>
                                                <Label for="exampleEmail" sm={4}>
                                                    Masa Berlaku SIM
                                                </Label>
                                                <Col sm={7}>
                                                    <Input
                                                    autoComplete="off"
                                                        className="form-control-alternative"
                                                        type="date"
                                                       
                                                        placeholder="Masukan Masa Berlaku SIM"
                                                        value={masasim}
                                                        onChange={(e) => {
                                                            setMasaSim(e.target.value);
                                                        }}
                                                    />
                                                </Col>
                                            </FormGroup>
                                            <FormGroup row>
                                                <Label for="exampleEmail" sm={4}>
                                                    Tanggal Bekerja
                                                </Label>
                                                <Col sm={7}>
                                                    <Input
                                                    autoComplete="off"
                                                        className="form-control-alternative"
                                                        type="date"
                                                        name="itemCode"
                                                        placeholder="Tanggal Bekerja"
                                                        value={awal}
                                                        onChange={(e) => {
                                                            setAwal(e.target.value);
                                                        }}
                                                    />
                                                </Col>
                                            </FormGroup>
                                            <FormGroup row>
                                                <Label
                                                    for="exampleEmail"
                                                    sm={4}
                                                >
                                                    Profile
                                                </Label>
                                                <Col sm={7}>
                                                <Input
                                                autoComplete="off"
                                                    className="form-control-alternative"
                                                    id="exampleFile"
                                                    name="file"
                                                    type="file"
                                                    accept="image/*"
                                                    onChange={(event) => {
                                                        setImage(event.target.files[0]);
                                                    }}
                                                    />
                                                </Col>
                                            </FormGroup>
                                        </CardBody>
                                    </Col>
                                </Row>
                            </Card>
                            <Card className="bg-secondary shadow">
                                <CardHeader className="bg-white border-0">
                                    <h3>DATA SAUDARA</h3>
                                </CardHeader>
                                <Row md="12">
                                    <Col md="6">
                                        <CardBody>
                                            <FormGroup row>
                                                <Label for="exampleEmail" sm={4}>
                                                    Nama 
                                                </Label>
                                                <Col sm={7}>
                                                    <Input
                                                    autoComplete="off"
                                                        className="form-control-alternative"
                                                        type="text"
                                                       
                                                        placeholder="Masukan Nama Lengkap"
                                                        value={namakk}
                                                        onChange={(e) => {
                                                            setNamaKK(e.target.value);
                                                        }}
                                                    />
                                                </Col>
                                            </FormGroup>
                                            <FormGroup row>
                                                <Label for="exampleEmail" sm={4}>
                                                    Alamat
                                                </Label>
                                                <Col sm={7}>
                                                    <Input
                                                    autoComplete="off"
                                                        className="form-control-alternative"
                                                        type="text"
                                                       
                                                        placeholder="Masukan Alamat"
                                                        value={alamatkk}
                                                        onChange={(e) => {
                                                            setAlamatKK(e.target.value);
                                                        }}
                                                    />
                                                </Col>
                                            </FormGroup>
                                            <FormGroup row>
                                                <Label
                                                for="exampleEmail"
                                                sm={4}
                                                >
                                                Jenis Kelamin
                                                </Label>
                                                <Col sm={7}>
                                                    <div style={{ display: "flex" }}>
                                                        <div className="custom-control custom-radio mb-3">
                                                            <Input
                                                            autoComplete="off"
                                                            className="custom-control-input"
                                                            id="customRadio13"
                                                            name="custom-radio-5"
                                                            type="radio"
                                                            value={1}
                                                            checked={genderkk === 1}
                                                            onChange={() => setGenderKK(1)}
                                                            />
                                                            <Label
                                                            className="custom-control-label"
                                                            htmlFor="customRadio13"
                                                            >
                                                            Laki-Laki
                                                            </Label>
                                                        </div>
                                                        <div
                                                            className="custom-control custom-radio mb-3"
                                                            style={{ marginLeft: "20px" }}
                                                        >
                                                            <Input
                                                            autoComplete="off"
                                                            className="custom-control-input"
                                                            id="customRadio14"
                                                            name="custom-radio-5"
                                                            type="radio"
                                                            value={2}
                                                            checked={genderkk === 2}
                                                            onChange={() => setGenderKK(2)}
                                                            />
                                                            <Label
                                                            className="custom-control-label"
                                                            htmlFor="customRadio14"
                                                            >
                                                            Perempuan
                                                            </Label>
                                                        </div>
                                                    </div>
                                                </Col>
                                            </FormGroup>
                                        </CardBody>
                                    </Col>
                                    <Col md="6">
                                        <CardBody>
                                            <FormGroup row>
                                                <Label for="exampleEmail" sm={4}>
                                                    Status Perkawinan
                                                </Label>
                                                <Col sm={7}>
                                                    <Input
                                                    autoComplete="off"
                                                        className="form-control-alternative"
                                                        type="select"
                                                       
                                                        placeholder="Masukan Status"
                                                        value={statuskk}
                                                        onChange={(e) => {
                                                            setStatusKK(e.target.value);
                                                        }}>
                                                        <option value="" disabled selected hidden>Pilih Status Perkawinan</option>
                                                        <option value="1">Belum Nikah</option>
                                                        <option value="2">Sudah Nikah</option>
                                                    </Input>
                                                </Col>
                                            </FormGroup>
                                            
                                            <FormGroup row>
                                                <Label for="exampleEmail" sm={4}>
                                                    Telephone
                                                </Label>
                                                <Col sm={7}>
                                                    <Input
                                                    autoComplete="off"
                                                        className="form-control-alternative"
                                                        type="text"
                                                       
                                                        placeholder="Masukan Telepone"
                                                        value={teleponkk}
                                                        onChange={(e) => {
                                                            setTeleponKK(e.target.value);
                                                        }}
                                                    />
                                                </Col>
                                            </FormGroup>
                                            <FormGroup row>
                                                <Label for="exampleEmail" sm={4}>
                                                    Hubungan
                                                </Label>
                                                <Col sm={7}>
                                                    <Input
                                                    autoComplete="off"
                                                        className="form-control-alternative"
                                                        type="text"
                                                       
                                                        placeholder="Masukan Hubungan"
                                                        value={hubungankk}
                                                        onChange={(e) => {
                                                            setHubunganKK(e.target.value);
                                                        }}
                                                    />
                                                </Col>
                                            </FormGroup>
                                        </CardBody>
                                    </Col>
                                </Row>
                                <CardFooter>
                                    {!isLoading && (<Button color="primary"  onClick={() => CreateData()}>
                                    Simpan
                                    </Button>)}
                                    {isLoading && (
                                    <Button color="primary" disabled>
                                        <i className="fas fa-spinner fa-spin"></i>
                                        {""}
                                        loading...
                                    </Button>
                                    )}
                                    <Link className="btn btn-info" to="/admin/karyawan">
                                    Kembali
                                    </Link>
                                </CardFooter>
                            </Card>
						</div>
					</Row>
				</Container>
			</div>
		</>
	);
}
